import { ReactNode, useEffect, useRef, useState } from "react"
import './index.scss'
import DrawerDialog, { DrawerDialogRef } from "../Base/DrawerDialog"
import Block from "../Base/Block"
import View from "../Base/View"
import ScrollView from "../Base/ScrollView"
import CouponItem from "../CouponItem"
import util from "../../utils/util"

const CouponChoosePannel = (prop: {
    discountValid: any[],
    discountInvalid: any[],
    children: ReactNode,
    onSelect?: (coupon: any, isValid: boolean) => void
}) => {
    const [currentTab, setCurrentTab] = useState<number>(0)
    const [selectCoupon, setSelectCoupon] = useState<any>();
    const [selectIndex, setSelectIndex] = useState<number>(-1);
    const [discountInvalid, setDiscountInvalid] = useState<any[]>([]);
    const [discountValid, setDiscountValid] = useState<any[]>([]);

    const drawerRef = useRef<DrawerDialogRef>()


    useEffect(() => {
        const newValue = prop.discountInvalid;
        if (typeof newValue !== typeof undefined && newValue.length > 0) {
            newValue.forEach(function (item, index, attr) {
                item.StartDate = util.getTimeArry(item.StartDate)
                item.EndDate = util.getTimeArry(item.EndDate)
            })
            setDiscountInvalid(newValue)
        }
    }, [prop.discountInvalid])

    useEffect(() => {
        const newValue = prop.discountValid;
        if (typeof newValue !== typeof undefined && newValue.length > 0) {
            newValue.forEach(function (item, index, attr) {
                item.StartDate = util.getTimeArry(item.StartDate)
                item.EndDate = util.getTimeArry(item.EndDate)
            })
            setDiscountValid(newValue)
            console.log("setDiscountValid", newValue)
        }
    }, [prop.discountValid])

    const _onItemClick = (couponInfo: any, index: number) => {
        var coupon = couponInfo
        var isCancel = selectIndex === index
        setSelectCoupon(isCancel
            ? undefined
            : coupon
        )
        setSelectIndex(isCancel ? -1 : index)
    }

    const _confirmClick = () => {
        if (prop.onSelect) {
            prop.onSelect(selectCoupon, currentTab === 0)
        }
        drawerRef.current?.close()
    }

    const rendList = currentTab === 0 ? discountValid : discountInvalid

    return <>

        <Block>
            <View onClick={() => {
                drawerRef.current?.open()
            }}>
                {prop.children}
            </View>
        </Block>

        <DrawerDialog
            direction={0}
            ref={drawerRef}
        >
            <Block>
                <View
                    className="pannel-content coupon-choose"
                // onTouchMove={this._consumeTouchmove}
                >
                    <View className="pannel-title flex-conainer">
                        <View
                            className={'tab ' + (currentTab === 0 ? 'active' : '')}
                            // data-index="0"
                            onClick={() => {
                                setCurrentTab(0)
                            }}
                        >
                            {'可用优惠券 (' + discountValid?.length + ')'}
                        </View>
                        <View
                            className={'tab ' + (currentTab === 1 ? 'active' : '')}
                            // data-index="1"
                            onClick={() => {
                                setCurrentTab(1)
                            }}
                        >
                            {'不可用优惠券 (' + discountInvalid?.length + ')'}
                        </View>
                    </View>
                    {rendList.length === 0 ? (
                        <View className="empty-tip-1">没有优惠券</View>
                    ) : (
                        <ScrollView
                            className={
                                'coupon-list ' +
                                (currentTab === 1 ? 'coupon-list-disable' : '')
                            }
                            scrollY={true}
                            enableBackToTop={true}
                            scrollWithAnimation={true}
                        >
                            <Block>
                                {rendList.map(
                                    (item, index) => {
                                        return (
                                            <CouponItem
                                            key={`${item.Id}-${index}`}
                                            couponInfo={item}
                                            state={5 - currentTab}
                                            select={selectIndex === index}
                                            // data-index={index}
                                            onClick={() => {
                                                _onItemClick(item, index)
                                            }}
                                        ></CouponItem>
                                        )
                                    }
                                )}
                            </Block>
                        </ScrollView>
                    )}
                    <View className="confirm-btn" onClick={_confirmClick}>
                        确定
                    </View>
                </View>
            </Block>

        </DrawerDialog>
    </>
}

export default CouponChoosePannel;